module.exports = __webpack_public_path__ + "media/images/publish-icon-99a4352871c3b9da6fe900d2f0af98e0.svg";